export default "__VITE_ASSET__DolP3r7E__"